import {
  MRT_ColumnFiltersState,
  MRT_RowData,
  MRT_SortingState,
  MRT_TableInstance,
  MRT_TableState,
} from "material-react-table";
import { isEqual } from "lodash";

type ResettableMrtState<TData extends MRT_RowData> = Pick<
  MRT_TableState<TData>,
  "columnFilters" | "globalFilter" | "sorting"
>;

const sortingStatesMatch = (
  currentSorting: MRT_SortingState,
  initialSorting: MRT_SortingState
) =>
  currentSorting.length === initialSorting.length &&
  currentSorting.every(
    (sorting, index) =>
      sorting.id === initialSorting[index]?.id &&
      sorting.desc === initialSorting[index]?.desc
  );

export const columnFilterStatesMatch = (
  currentFilters: MRT_ColumnFiltersState,
  initialFilters: MRT_ColumnFiltersState,
) => {
  if (currentFilters.length !== initialFilters.length) return false;

  const sortByColumnId = (filters: MRT_ColumnFiltersState) =>
    [...filters].sort((first, second) => first.id.localeCompare(second.id));

  return isEqual(
    sortByColumnId(currentFilters),
    sortByColumnId(initialFilters),
  );
};

export const hasMrtFiltersToReset = <TData extends MRT_RowData>(
  state: ResettableMrtState<TData>,
  initialSorting: MRT_SortingState = []
) => {
  const hasGlobalFilter =
    typeof state.globalFilter === "string"
      ? state.globalFilter !== ""
      : Boolean(state.globalFilter);

  return (
    hasGlobalFilter ||
    state.columnFilters.length > 0 ||
    !sortingStatesMatch(state.sorting, initialSorting)
  );
};

export const resetMrtFilters = <TData extends MRT_RowData>(
  table: MRT_TableInstance<TData>,
  initialSorting: MRT_SortingState = []
) => {
  table.setGlobalFilter("");
  table.setColumnFilters([]);
  table.setSorting([...initialSorting]);
};
